<template>
  <v-container fluid>	
		<div class="text-center">
			<v-overlay :value="modelCarga">
			<v-progress-circular
				indeterminate
				size="64"
			></v-progress-circular>
			</v-overlay>
		</div>
		<v-snackbar
                v-model="snackbar" top vertical="" :timeout="4000"
                >
                {{ Mensaje }}
                <v-btn
                color="pink"
                text
                @click="snackbar = false"
                >
                Close
                </v-btn>
        </v-snackbar>
		
			<v-data-table
				:headers="cabeceraDetalles"
				:items="lotes"
				:search="search"
				sort-by="calories"
				class="elevation-1"
			>
				<template v-slot:top>
				<v-toolbar
					flat
				>
					<v-toolbar-title>Lotes de Producción</v-toolbar-title>
					<v-divider
					class="mx-4"
					inset
					vertical
					></v-divider>
					<v-text-field filled v-model="search"  append-icon="mdi-magnify"
                         label="Buscar" single-line hide-details
                        />
					<v-divider
					class="mx-4"
					inset
					vertical
					></v-divider>
				<v-dialog
				v-model="dialogTransfer"
				max-width="800px"
				>
					<v-card>
						<v-card-title>
						<span class="text-h5">Transferencia de Unidades </span>
						</v-card-title>
						<v-card-text>
						<v-container>
							<v-row>
								
								<div class="mx-2" style="width:48%" > 
										<v-text-field disabled v-model="IdOrigen" filled hide-details="" type="number" label="Id Lote Origen" /> 
										<v-text-field v-model="Unidades" filled hide-details="" type="number" label="Unidades a trazladar" /> 
									</div>
									<div style="width:48%" > 
										<v-text-field disabled v-model="IdDestino" filled hide-details="" type="text" label="Id Lote Destino" />
									</div>
							</v-row>
						</v-container>
						</v-card-text>

						<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn
							color="blue darken-1"
							text
							@click="dialogTransfer = false"
						>
							Cancelar
						</v-btn>
						<v-btn
							color="primary"
							:loading="modelCarga"
							@click="TransferirLote(ArrayOriigin)"
						>
							Transferir
						</v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>
				<v-dialog
				v-model="dialog"
				max-width="800px"
				>
					<template v-slot:activator="{ on, attrs }">
						<v-btn
						color="primary"
						dark
						class="mb-2"
						v-bind="attrs"
						v-on="on"
						>
						New Item
						</v-btn>
					</template>
					<v-card>
						<v-card-title>
						<span class="text-h5">{{formTitle }}</span>
						</v-card-title>

						<v-card-text>
						<v-container>
							<v-row>
								
								<div class="mx-2" style="width:48%" > 
										<v-text-field v-model="NoLote" filled hide-details="" type="number" label="Número de lote" /> 
										<v-text-field v-model="Unidades" filled hide-details="" type="number" label="Unidades" /> 
										<v-text-field v-model="Fecha" filled hide-details="" type="date" label="Fecha Inicial" /> 
										<v-text-field v-model="FechaFinal" filled hide-details="" type="date" label="Fecha Final" /> 
										<v-select v-model="Estado" filled hide-details="" label="Estado" :items="Estados" /> 
										<v-select v-model="Ubicacion" filled hide-details="" label="Ubicación" :items="ubicaciones" /> 
									</div>
									<div style="width:48%" > 
										<v-text-field v-model="Tamaño" filled hide-details="" type="text" label="Tamaño Actual" />
										<v-text-field v-model="NombreComun" filled hide-details="" type="text" label="Nombre Común" />
										<v-text-field v-model="Contenedor" filled hide-details="" type="text" label="Contenedor" />
										<v-text-field v-model="NombreCientifico" filled hide-details="" type="text" label="Nombre Cientifico" />
										<v-select v-model="MetodoPropagacion" :items="MetodosProgramacion" filled hide-details="" type="text" label="Método de propagación" />
									</div>
							</v-row>
						</v-container>
						</v-card-text>

						<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn
							color="blue darken-1"
							text
							@click="dialog = false"
						>
							Cancelar
						</v-btn>
						<v-btn
							color="primary"
							:loading="modelCarga"
							@click="CargarLote()"
						>
							Cargar Lote
						</v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>
				</v-toolbar>
				</template>
				<template v-slot:item.metodoPropagacion="props">
					<v-edit-dialog
					:return-value.sync="props.item.metodoPropagacion"
					@save="ActualizarLote(props.item)"
					large
					>
					{{props.item.metodoPropagacion}}
					<template v-slot:input>
						<v-select v-model="props.item.metodoPropagacion" label="Método Propagación" :items="MetodosProgramacion" /> 
					</template>
					</v-edit-dialog>
				</template>
				<template v-slot:item.contenedor="props">
					<v-edit-dialog
					:return-value.sync="props.item.contenedor"
					@save="ActualizarLote(props.item)"
					large
					>
					{{props.item.contenedor}}
					<template v-slot:input>
						<v-text-field v-model="props.item.contenedor" label="Ubicación" /> 
					</template>
					</v-edit-dialog>
				</template>
				<template v-slot:item.tamaño="props">
					<v-edit-dialog
					:return-value.sync="props.item.tamaño"
					@save="ActualizarLote(props.item)"
					large
					>
					{{props.item.tamaño}}
					<template v-slot:input>
						<v-text-field v-model="props.item.tamaño" label="Ubicación" /> 
					</template>
					</v-edit-dialog>
				</template>
				<template v-slot:item.ubicacion="props">
					<v-edit-dialog
					:return-value.sync="props.item.ubicacion"
					@save="ActualizarLote(props.item)"
					large
					>
					{{props.item.ubicacion}}
					<template v-slot:input>
						<v-select v-model="props.item.ubicacion" label="Ubicación" :items="ubicaciones" /> 
					</template>
					</v-edit-dialog>
				</template>
				<template v-slot:item.logs="{ item }">
					<div @click="toggleRow(item)">
						<!-- Muestra el texto truncado o completo basado en el estado de 'expandedRows' -->
						{{ expandedRows.includes(item.logs) ? item.logs : truncate(item.logs, 100) }}
					</div>
				</template>
				<template v-slot:item.estado="props">
					<v-edit-dialog
					:return-value.sync="props.item.estado"
					@save="ActualizarLote(props.item)"
					large
					>
					{{props.item.estado}}
					<template v-slot:input>
						<v-select v-model="props.item.estado" filled hide-details="" label="Estado" :items="Estados" /> 
					</template>
					</v-edit-dialog>
				</template>
				<template v-slot:item.unidades="props">
					<v-edit-dialog
					:return-value.sync="props.item.unidades"
					@save="ActualizarLote(props.item)"
					large
					>
					{{props.item.unidades}}
					<template v-slot:input>
						<v-text-field  v-model="props.item.unidades" label="Nuevas Unidades"/>
					</template>
					</v-edit-dialog>
				</template>
				<template v-slot:item.nombreCientifico="props">
					<v-edit-dialog
					:return-value.sync="props.item.nombreCientifico"
					@save="ActualizarLote(props.item)"
					large
					>
					{{props.item.nombreCientifico}}
					<template v-slot:input>
						<v-text-field  v-model="props.item.nombreCientifico" label="Nuevo Nombre"/>
					</template>
					</v-edit-dialog>
				</template>
				<template v-slot:item.nombreComun="props">
					<v-edit-dialog
					:return-value.sync="props.item.nombreComun"
					@save="ActualizarLote(props.item)"
					large
					>
					{{props.item.nombreComun}}
					<template v-slot:input>
						<v-text-field  v-model="props.item.nombreComun" label="Nuevo Nombre Común"/>
					</template>
					</v-edit-dialog>
				</template>
				<template v-slot:item.actions="{ item }">
				<v-icon
					small
					v-if="!TransActivate"
					class="mr-2"
					@click="Lotransfer(item)"
				>
					mdi-swap-horizontal
				</v-icon>
				<v-icon
					v-if="TransActivate"
					color="green"
					class="mr-2"
					@click="SetFinalID(item)"
				>
					mdi-check
				</v-icon>
				<v-icon
					small
					@click="BorrarLote(item)"
				>
					mdi-delete
				</v-icon>
				</template>
				<template v-slot:no-data>
				<v-btn
					color="primary"
				>
					Reset
				</v-btn>
				</template>
			</v-data-table>
  </v-container>
</template>


<script>
  
  import axios from 'axios';
  export default {
    name: 'Recetas',
    data () {
      return {
		Hora:null,
		Fecha:null,
		Usuario: '',
		Localidad: '',
		NoLote: 0,
		Tamaño: 0,
		Logs:'',
		Unidades: 0,
		NombreCientifico:'',
		IdOrigen:0,
		IdDestino:0,
		ArrayOriigin: [],
		ArrayDetiny:[],
		FechaFinal:null,
		Contenedor: '',
		Estado: '',
		MetodoPropagacion: '',
		Ubicacion: '',
		NombreComun: '',
		MetodosProgramacion: ["Semilla","Estaca","Acodo"],
		dialog: false,
      	dialogDelete: false,
		dialogTransfer:false,
        ProductoCompuesto : '',
        lotes:[],
		TransActivate: false,
		editedIndex: -1,
        modelCarga: false,
		ubicaciones:["Invernadero","Casa Malla","Campo"],
		Estados:["Pequeño","Mediano","Grande"],
		PrecioCostoPrevio: 0,
		snackbar : false,
		Mensaje :"",
		search:"",
		codigo:"",
		detalles:[],
		expandedRows: [], // Almacena las filas expandidas
		cabeceraDetalles: [
		{ text: 'Id', value: 'id'},
		{ text: 'Lote', value: 'noLote'},
		{ text: 'Nom Cientifico', value: 'nombreCientifico' },
		{ text: 'Nombre', value: 'nombreComun'},
		{ text: 'Unidades', value: 'unidades' },  
		{ text: 'Fecha Inicio', value: 'fecha'},  
		{ text: 'Fecha Fin', value: 'fechaFinal'},
		{ text: 'Estado', value: 'estado'},
		{ text: 'Ubicacion', value: 'ubicacion'},
		{ text: 'Tamaño', value: 'tamaño' },
		{ text: 'Contenedor', value: 'contenedor' },
		{ text: 'Método', value: 'metodoPropagacion' },
		{ text: 'Logs', value: 'logs'},
		{ text: 'Acciones', value: 'actions'},
		],
      }
    },
	computed:{
		formTitle () {
			return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
		},
		calcularCosto:function(){
			let resultado = 0;
				for(var i=0;i<this.detalles.length;i++){
					resultado=resultado+(this.detalles[i].precio * this.detalles[i].cantidad);
				}
			return resultado;
    	},
		calcularVenta:function(){
			let Ganancia = this.calcularCosto * (this.Utilidad / 100) ;
			let PrecioVenta = this.calcularCosto + Ganancia;
			let IvaPrecioVenta = PrecioVenta * 0.13;
			let resultado = (PrecioVenta + IvaPrecioVenta);
			return resultado;
    	},
	},
	created () {
		this.selectLotes();
	},
	
    methods: {
		truncate(text, length) {
			if (text.length <= length) return text;
			return text.substring(0, length) + '...';
		},
		toggleRow(item) {
			const index = this.expandedRows.indexOf(item.logs);
			if (index === -1) {
				this.expandedRows.push(item.logs);
			} else {
				this.expandedRows.splice(index, 1);
			}
		},
		Lotransfer(item){
			//this.dialogTransfer = true;
			this.ArrayOriigin = item;
			this.IdOrigen =item.id;
			this.Unidades = item.unidades;
			this.TransActivate = true;
			this.snackbar = true;
			this.Mensaje = "Seleccione el lote destino";
		},
		SetFinalID(item){
			this.ArrayDetiny = item;
			this.dialogTransfer = true;
			this.IdDestino =item.id;
			this.TransActivate = false;
			this.snackbar = true;
			this.Mensaje = "Seleccione el lote destino";
		},
		SetPrecioVenta(){
			this.PrecioVenta = this.calcularVenta;
		},
		selectLotes(){
			let me=this;
			let header={"Authorization" : "Bearer " };
			let configuracion= {headers : header};
			var productosArray=[];
			axios.get('api/LotesProduccion/ListarLote/'+this.$store.state.usuario.localidad,configuracion).then(function(response){
				me.lotes=response.data;
				me.modelCarga = false;
				me.localidad = me.$store.state.usuario.localidad;
			}).catch(function(error){
				console.log(error);
			});
		},
		ActualizarCostos(){ 
			this.modelCarga = true;
			let header={"Authorization" : "Bearer "};
			let configuracion= {headers : header};
				//Código para editar
				let me=this;
				axios.put('api/Productos/ActualizarVentaCosto',{
					'CodigoProducto':me.ProductoCompuesto,
					'Localidad' : me.$store.state.usuario.localidad,
					'PrecioCompra': me.calcularCosto,
					'PrecioVenta': me.PrecioVenta,
				},configuracion).then(function(response){
					me.Mensaje = 'Precios actualizados';
					me.snackbar = true;          
					me.modelCarga = false;           
				}).catch(function(error){
					alert("Problema actualizando, por favor envie una foto de este problema a su equipo de soporte" +error);
					me.modelCarga= false;
				});
		},
		BuscarReceta(){
			let me=this;
			let header={"Authorization" : "Bearer "};
			let configuracion= {headers : header};
			axios.get('api/DescargaInventarios/GetDescargaInventario/'+this.$store.state.usuario.localidad+'/'+this.ProductoCompuesto,configuracion)
			.then(function(response){
				me.detalles = response.data
				me.buscarProductoMaster();
			}).catch(function(error){
				// me.snackbar = true;
						//me.Mensaje = "Producto No encontrado";
			});
			
		},
		ColorPrecioVenta(){
			if(this.PrecioVenta < this.calcularCosto)
			{
				return red;
			} 
			return green;
		},
		buscarProductoMaster(){
			let me=this;
			let header={"Authorization" : "Bearer "};
			let configuracion= {headers : header};
			axios.get('api/Productos/BuscarCodigoVenta/'+this.ProductoCompuesto+'/'+this.$store.state.usuario.localidad,configuracion)
			.then(function(response){
				me.NombreProducto = response.data.descripcion;
				me.PrecioVenta = response.data.precioVenta;
				me.PrecioCostoPrevio = response.data.precioCompra;
			}).catch(function(error){
				// me.snackbar = true;
						//me.Mensaje = "Producto No encontrado";
			});
		},
		async BorrarLote(item){

			if(confirm("Seguro que quiere eliminar este Lote? "+item.NombreCientifico)){
			this.modelCarga = true;
			let me = this;
			let header={"Authorization" : "Bearer " + this.$store.state.token};
			let configuracion= {headers : header};
			await axios.delete('api/LotesProduccion/'+item.id,{
						
				},configuracion).then(function (response) {
						me.snackbar = true;
						me.Mensaje = "Eliminado con éxito";
						me.selectLotes()
						me.modelCarga = false;
					})
					.catch(function (error) {
						me.modelCarga = false;
						alert(`Error Eliminando`);  
				})
			}
		},
		async CargarLote(){
			this.modelCarga = true;
			let me = this;
			let ahora = new Date();
        	this.Hora = ahora.getHours() + ':' + ahora.getMinutes() + ':' + ahora.getSeconds();
			let header={"Authorization" : "Bearer " + this.$store.state.token};
			let configuracion= {headers : header};
			await axios.post('api/LotesProduccion',{
					'Hora':this.Hora,
					'Fecha': this.Fecha,
					'Usuario': this.$store.state.usuario.nombre,
					'Localidad': this.$store.state.usuario.localidad,
					'NoLote': this.NoLote,
					'Tamaño': this.Tamaño,
					'Logs': this.Logs,
					'Unidades': this.Unidades,
					'NombreCientifico': this.NombreCientifico,
					'FechaFinal': this.FechaFinal,
					'Contenedor': this.Contenedor,
					'Estado': this.Estado,
					'MetodoPropagacion': this.MetodoPropagacion,
					'Ubicacion': this.Ubicacion,
					'NombreComun': this.NombreComun,
						
				},configuracion).then(function (response) {
						me.snackbar = true;
						me.Mensaje = "Lote Cargado con éxito";
						me.modelCarga = false;
						me.dialog = false;
						me.LimpiarData();
						me.selectLotes();
					})
					.catch(function (error) {
						me.modelCarga = false;
						alert(`Error Cargando lote `+error);  
				})
			
		},
		async ActualizarLote(item){
			this.modelCarga = true;
			let me = this;
			let ahora = new Date();
        	this.Hora = ahora.getHours() + ':' + ahora.getMinutes() + ':' + ahora.getSeconds();
			let header={"Authorization" : "Bearer " + this.$store.state.token};
			let configuracion= {headers : header};
			await axios.put('api/LotesProduccion/'+item.id,{
					'id':item.id,
					'Hora':me.Hora,
					'Fecha': item.fecha,
					'Usuario': me.$store.state.usuario.nombre,
					'Localidad': me.$store.state.usuario.localidad,
					'NoLote': item.noLote,
					'Tamaño': item.tamaño,
					'Logs': item.logs + ' ,Actualizado a las '+this.Hora+ ' por '+this.$store.state.usuario.nombre,
					'Unidades': item.unidades,
					'NombreCientifico': item.nombreCientifico,
					'FechaFinal': item.fechaFinal,
					'Contenedor': item.contenedor,
					'Estado': item.estado,
					'MetodoPropagacion': item.metodoPropagacion,
					'Ubicacion': item.ubicacion,
					'NombreComun': item.nombreComun,
						
				},configuracion).then(function (response) {
						me.snackbar = true;
						me.Mensaje = "Lote actualizado con éxito";
						me.modelCarga = false;
						me.dialog = false;
						me.LimpiarData();
						me.selectLotes();
					})
					.catch(function (error) {
						me.modelCarga = false;
						alert(`Error Cargando lote `+error);  
				})
			
		},
		async TransferirLote(item){
			this.modelCarga = true;
			let me = this;
			let ahora = new Date();
			let unidadestransferidas = parseInt(item.unidades) - parseInt(this.Unidades);
        	this.Hora = ahora.getHours() + ':' + ahora.getMinutes() + ':' + ahora.getSeconds();
			let header={"Authorization" : "Bearer " + this.$store.state.token};
			let configuracion= {headers : header};
			await axios.put('api/LotesProduccion/'+item.id,{
					'id':item.id,
					'Hora':me.Hora,
					'Fecha': item.fecha,
					'Usuario': me.$store.state.usuario.nombre,
					'Localidad': me.$store.state.usuario.localidad,
					'NoLote': item.noLote,
					'Tamaño': item.tamaño,
					'Logs': item.logs + ' Transferencia de '+unidadestransferidas+ ' unidades hacia lote '+this.ArrayDetiny.noLote,
					'Unidades': unidadestransferidas,
					'NombreCientifico': item.nombreCientifico,
					'FechaFinal': item.fechaFinal,
					'Contenedor': item.contenedor,
					'Estado': item.estado,
					'MetodoPropagacion': item.metodoPropagacion,
					'Ubicacion': item.ubicacion,
					'NombreComun': item.nombreComun,
						
				},configuracion).then(function (response) {
						me.TransferDetiny(me.ArrayDetiny);
					})
					.catch(function (error) {
						me.modelCarga = false;
						alert(`Error Transfiriendo lote origen`+error);  
				})
			
		},
		async TransferDetiny(item){
			this.modelCarga = true;
			let me = this;
			let ahora = new Date();
			
			let unidadestransferidas = parseInt(item.unidades) + parseInt(this.Unidades);
        	this.Hora = ahora.getHours() + ':' + ahora.getMinutes() + ':' + ahora.getSeconds();
			let header={"Authorization" : "Bearer " + this.$store.state.token};
			let configuracion= {headers : header};
			await axios.put('api/LotesProduccion/'+item.id,{
					'id':item.id,
					'Hora':me.Hora,
					'Fecha': item.fecha,
					'Usuario': me.$store.state.usuario.nombre,
					'Localidad': me.$store.state.usuario.localidad,
					'NoLote': item.noLote,
					'Tamaño': item.tamaño,
					'Logs': item.logs + ', '+unidadestransferidas+ ' unidades recibidas de lote '+this.ArrayOriigin.noLote,
					'Unidades': unidadestransferidas,
					'NombreCientifico': item.nombreCientifico,
					'FechaFinal': item.fechaFinal,
					'Contenedor': item.contenedor,
					'Estado': item.estado,
					'MetodoPropagacion': item.metodoPropagacion,
					'Ubicacion': item.ubicacion,
					'NombreComun': item.nombreComun,
						
				},configuracion).then(function (response) {
						me.snackbar = true;
						me.Mensaje = "Lote actualizado con éxito";
						me.modelCarga = false;
						me.dialogTransfer = false;
						me.selectLotes();
					})
					.catch(function (error) {
						me.modelCarga = false;
						alert(`Error Transfiriendo lote destino`+error);  
				})
			
		},
		LimpiarData(){
			this.NoLote = 0;
			this.Unidades = 0;
			this.Fecha = null;
			this.FechaFinal = null;
			this.Estado = null;
			this.Ubicacion = '';
			this.Tamaño = '';
			this.NombreComun;
			this.Contenedor = '';
			this.NombreComun = '';
			this.NombreCientifico = '';
			this.MetodoPropagacion = '';
		},
		buscarProductoDirecto(){
			let me=this;
			if (this.codigo.value === undefined)
			{
				this.codigo = this.codigo;
			}
			else
			{
				this.codigo = this.codigo.value;
			}

			if (this.codigo != "")
			{
				let header={"Authorization" : "Bearer "};
				let configuracion= {headers : header};
				axios.get('api/Productos/BuscarCodigoVenta/'+this.codigo+'/'+this.$store.state.usuario.localidad,configuracion)
				.then(function(response){
					me.agregarDetalleDirecto(response.data);
				}).catch(function(error){
					// me.snackbar = true;
							//me.Mensaje = "Producto No encontrado";
				});
			}
		},
		
		agregarDetalleDirecto(data = []){
			let me = this;
			this.modelCarga = false;
			let header={"Authorization" : "Bearer " + this.$store.state.token};
			let configuracion= {headers : header};
			axios.post('api/DescargaInventarios ',{
					'codigoasoiado':data['codigoProducto'],
					'codigoCompuesto': this.ProductoCompuesto,
					'cantidad': this.cantidad,
					'descripcion': data['descripcion'],
					'Precio': data['precioCompra'],
					'UnidadMedida': 0,
					'localidad': this.$store.state.usuario.localidad,
				},configuracion).then(function (response) {
						me.Mensaje = "Producto Agregado con éxito.";
                    	me.snackbar = true;
						me.modelCarga = false;
						me.AgregarInsumo(response.data)
					})
					.catch(function (error) {
						me.modelCarga = false; 
						alert(`Problema Cargando el producto a la base de datos, compruebe la existencia`+error); 
						
				})	
			this.codigo = '';
			this.cantidad = 0;
		},
		AgregarInsumo(data = []){
			this.detalles.push(
				{
				id: data['id'], 
				codigoAsoiado:data['codigoasoiado'],
				codigoCompuesto:data['codigoCompuesto'],
				cantidad: data['cantidad'],
				descripcion:data['descripcion'],
				precio:data['precio'],
				unidadMedida:data['unidadMedida'],
				}
				);
			
		}
	}
  }
</script>
